// extracted by mini-css-extract-plugin
module.exports = {"section":"PrivacyTerms_section__wRT6X"};